// extracted by mini-css-extract-plugin
module.exports = {"tagSuffix":"StyledTag_tagSuffix__iWmQ2","tagContent":"StyledTag_tagContent__UVMmu"};